import { useState } from "react";
import { Alert } from "@interstate/components/Alert";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { LeadStatusType } from "@coxauto-ui/cxm/communications/interfaces";
import { StyledContainerAlert } from "./styled";

export interface InactiveLeadWarningAlertProps {
  autoLeadStatus: LeadStatusType;
}

export function InactiveLeadWarningAlert({
  autoLeadStatus
}: InactiveLeadWarningAlertProps) {
  const [dismissed, setDismissed] = useState(false);

  const showLeadWarning =
    autoLeadStatus !== LeadStatusType.ACTIVE &&
    autoLeadStatus !== LeadStatusType.NONE;

  if (!showLeadWarning || dismissed) {
    return null;
  }

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="inactive-lead-warning-message-reply-app"
        displayCloseButton={true}
        role="info"
        type="info"
        onCloseClick={() => setDismissed(true)}
      >
        <span>{ErrorMessages.INACTIVE_LEAD_WARNING}</span>
      </Alert>
    </StyledContainerAlert>
  );
}
